// Recovered compiled webpack factory 33152. Edit this function expression; run npm run build.
(t, e, i) => {
  function n({ top: t, left: e, right: i, bottom: n }) {
    return { x: { min: e, max: i }, y: { min: t, max: n } };
  }
  function s({ x: t, y: e }) {
    return { top: e.min, right: t.max, bottom: e.max, left: t.min };
  }
  function r(t, e) {
    if (!e) return t;
    let i = e({ x: t.left, y: t.top }),
      n = e({ x: t.right, y: t.bottom });
    return { top: i.y, left: i.x, bottom: n.y, right: n.x };
  }
  i.d(e, { FY: () => n, bS: () => r, pA: () => s });
}
